import React, {useEffect} from 'react';
import {useTitle} from "../../../contexts/title";
import StoreNoteGrid from '../../../features/cfi/notes/components/StoreNoteGrid';
import {KindOfOrder} from '../../../types/enums';

export default function LeadNotesPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Lead Notes')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<StoreNoteGrid kindOfOrder={KindOfOrder.Estimate} />
			</div>
		</React.Fragment>
	)
} 
